module.exports = __webpack_public_path__ + "img/logo-header-min.de3e1251.svg";